import React, { useState } from 'react';

const ContactFooterWithForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    description: ''
  });
  const [showModal, setShowModal] = useState(false);

  const handleChange = e => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const res = await fetch('http://localhost:5000/api/prayer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      if (res.ok) {
        setFormData({ name: '', email: '', mobile: '', description: '' });
        setShowModal(true);
      } else {
        alert('Submission failed');
      }
    } catch (err) {
      console.error(err);
      alert('Error submitting form');
    }
  };

  return (
    <footer style={{ background: 'linear-gradient(135deg, #0f2027, #203a43, #2c5364)', color: '#fff', padding: '60px 20px' }}>
      <div style={{ textAlign: 'center', marginBottom: '50px' }}>
        <h2 style={{ fontSize: '2.8rem', fontWeight: '700', color: '#00ffe0', marginBottom: '10px' }}>📞 Contact Us</h2>
        <p style={{ fontSize: '1.2rem', color: '#cfd8dc' }}>
          We’d love to hear from you! Submit a prayer or reach out to us below.
        </p>
      </div>

      {/* Contact Info Cards */}
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '40px', marginBottom: '60px' }}>
        {[
          { icon: '📍', title: 'Address', text: '123 Faith Lane\nNew Foundation City, Australia' },
          { icon: '📞', title: 'Phone', text: '+61 400 123 456' },
          { icon: '📧', title: 'Email', text: 'info@newfoundationtrust.org' }
        ].map((item, i) => (
          <div key={i} style={{
            background: '#16213e',
            padding: '30px',
            borderRadius: '16px',
            width: '260px',
            textAlign: 'center',
            boxShadow: '0 8px 20px rgba(0, 255, 224, 0.2)',
            transition: 'transform 0.3s, box-shadow 0.3s',
            cursor: 'default'
          }} onMouseEnter={e => {
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 12px 25px rgba(0, 255, 224, 0.4)';
          }} onMouseLeave={e => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 255, 224, 0.2)';
          }}>
            <div style={{ fontSize: '2.2rem', color: '#00ffe0', marginBottom: '12px' }}>{item.icon}</div>
            <h4 style={{ fontSize: '1.4rem', marginBottom: '8px' }}>{item.title}</h4>
            <p style={{ whiteSpace: 'pre-line', color: '#cfd8dc' }}>{item.text}</p>
          </div>
        ))}
      </div>

      {/* Prayer Request Form */}
      <div style={{ maxWidth: '650px', margin: '0 auto', textAlign: 'left' }}>
        <h3 style={{ fontSize: '2rem', color: '#00ffe0', marginBottom: '25px', textAlign: 'center' }}>🙏 Submit a Prayer Request</h3>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
          <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required style={inputStyle} />
          <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required style={inputStyle} />
          <input type="text" name="mobile" placeholder="Mobile Number" value={formData.mobile} onChange={handleChange} required style={inputStyle} />
          <textarea name="description" placeholder="Your Prayer Request..." value={formData.description} onChange={handleChange} required style={textareaStyle} />
          <button type="submit" style={submitButtonStyle}>Send Prayer</button>
        </form>
      </div>

      {/* Social Icons */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: '25px', marginTop: '50px' }}>
        {['🌐','📘','📸','🐦'].map((icon,i)=>(
          <a key={i} href="#" style={socialIconStyle}>{icon}</a>
        ))}
      </div>

      {/* Footer Bottom */}
      <div style={{ textAlign: 'center', marginTop: '40px', borderTop: '1px solid #333', paddingTop: '20px', color: '#aaa', fontSize: '0.9rem' }}>
        &copy; {new Date().getFullYear()} New Foundation Trust. All Rights Reserved.
      </div>

      {/* Popup Modal */}
      {showModal && (
        <div style={modalOverlayStyle}>
          <div style={modalBoxStyle}>
            <h3 style={{ color: '#00ffe0', fontSize: '1.8rem', marginBottom: '15px' }}>🙏 Thank You!</h3>
            <p style={{ fontSize: '1.1rem', color: '#333' }}>Your prayer request has been received.</p>
            <button onClick={() => setShowModal(false)} style={modalButtonStyle}>Close</button>
          </div>
        </div>
      )}
    </footer>
  );
};

// Input & Button Styles
const inputStyle = {
  padding: '14px',
  borderRadius: '12px',
  border: 'none',
  background: '#1f1f1f',
  color: '#fff',
  fontSize: '1rem',
  boxShadow: 'inset 2px 2px 5px rgba(0,0,0,0.6), inset -2px -2px 5px rgba(255,255,255,0.05)',
  transition: 'all 0.3s',
};
const textareaStyle = { ...inputStyle, minHeight: '120px', resize: 'vertical' };
const submitButtonStyle = {
  padding: '14px',
  borderRadius: '12px',
  border: 'none',
  background: 'linear-gradient(135deg, #00ffe0, #00b8a9)',
  color: '#000',
  fontWeight: '700',
  cursor: 'pointer',
  fontSize: '1.1rem',
  transition: '0.3s all',
};
submitButtonStyle[':hover'] = { transform: 'scale(1.05)' };

const socialIconStyle = {
  fontSize: '2rem',
  color: '#00ffe0',
  textDecoration: 'none',
  transition: '0.3s',
};
socialIconStyle[':hover'] = { transform: 'scale(1.2)' };

// Modal Styles
const modalOverlayStyle = {
  position: 'fixed',
  top: 0, left: 0,
  width: '100vw', height: '100vh',
  backgroundColor: 'rgba(0,0,0,0.7)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000
};
const modalBoxStyle = {
  background: '#fff',
  padding: '35px',
  borderRadius: '15px',
  maxWidth: '420px',
  width: '90%',
  textAlign: 'center',
  boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
};
const modalButtonStyle = {
  marginTop: '20px',
  padding: '12px 25px',
  borderRadius: '10px',
  border: 'none',
  background: 'linear-gradient(135deg, #00ffe0, #00b8a9)',
  fontWeight: '700',
  cursor: 'pointer',
  color: '#000',
  fontSize: '1rem'
};

export default ContactFooterWithForm;
